import React from "react";

export default function FinancialInfo({ contract, handleInputChange }) {
  return (
    <>
      <div className="carousel-item">
        <div className="mt-5 pt-4">
          <form className="container">
            <h3 className="mb-3"> البنود المالية </h3>
            <div className="row">
              <div className="col-md-4">
                <div className="mb-3">
                  <label htmlFor="value" className="form-label">
                    قيمة العقد
                  </label>
                  <input type="number" value={contract.value} className="form-control" id="value" onChange={handleInputChange} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label htmlFor="payment_type" className="form-label">
                    نوع الدفع
                  </label>
                  <select className="form-select" value={contract?.payment_type} id="payment_type" onChange={handleInputChange}>
                    <option value="full">نقدي</option>
                    <option value="installments">دفعات</option>
                  </select>
                </div>
              </div>
              {contract.payment_type === "installments" && (
                <div className="col-md-4">
                  <div className="mb-3">
                    <label htmlFor="second_payment" className="form-label">
                      عدد الدفعات
                    </label>
                    <input type="number" value={contract?.installment_count} className="form-control" id="installment_count" onChange={handleInputChange} />
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-between mx-5 my-3">
          <div>
            <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
              <span>السابق</span>
            </button>
          </div>
          <div>
            {contract.payment_type === "full" && (
              <button className={`btn btn-primary ${contract.value === null && "d-none"}`} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                التالي
              </button>
            )}
            {contract.payment_type === "installments" && (
              <button className={`btn btn-primary ${contract.value === null || contract.first_payment === null || contract.second_payment === null || contract.second_payment_date === "" ? "d-none" : ""}`} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                التالي
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
